import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
// import { HttpRequestState, httpRequestStates } from 'ngx-http-request-state';
import { environment } from '@env/environment';
import { BehaviorSubject, catchError, map, mergeMap, Observable, of, retryWhen, tap, throwError, EMPTY } from 'rxjs';
import { genericRetryStrategy } from '@app/shared/utils';
import { Asistance, RequestStatusRefund, RefoundInfo, RequestRefoundInfo, SalesforceDocuments, Response, TypeExpense, RequestTypeExpense, DynamicFields, HttpRequestState} from '@app/interfaces';
import { httpRequestState } from '@app/shared/operators';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { BrandService } from '../brand/brand.service';
@Injectable({
  providedIn: 'root',
})
export class RefundService {
  public expensesLength = new BehaviorSubject<number>(0);
  public status: string = '';

  public documentosCargados: any[] = [];

  private _assistance$ = new BehaviorSubject<Asistance>(null as any);
  public assistance$ = this._assistance$.asObservable();

  private _textRefunds$ = new BehaviorSubject<RefoundInfo[]>([]);
  public textRefunds$ = this._textRefunds$.asObservable();
  public brandService = inject(BrandService);
  readonly refoundInfoState$: Observable<HttpRequestState<RefoundInfo[]>>;

  constructor(private http: HttpClient,private router: Router) {
    this.refoundInfoState$ = this.getRefoundInfo().pipe(httpRequestState());
  }

  getAssistanceOdoo(id: string) {
    return this.http.get<Response<boolean>>(
      `${environment.serverUrl}/refund/Refund/SendAssistenceOdoo/${id}`,
    );
  }

  getAssistanceById(id: string, idcert: string): Observable<Asistance> {
    return this.http
      .get<
        Response<Asistance>
      >(`${environment.serverUrl}/refund/Refund/GetAssistence/${id}/${idcert}`)
      .pipe(
        mergeMap((response) => {
          if (response?.result?.numberCase != null) {
            if (response.result.assistenceaccountbank.length > 0) {
              Swal.fire({
                title: '<span class="text-primary">Solicitud ya registrada</span>',
                html: `
                  <div style="color: #5F5F5F;">
                    Ya realizaste el diligenciamiento de este formulario.<br><br>
                    Por seguridad, este enlace no permite nuevos envíos ni modificaciones.
                    <br><br>
                    Si necesitas reportar otro caso, utiliza el enlace correspondiente a ese nuevo caso.
                  </div>
                `,
                showConfirmButton: true,
                confirmButtonText: 'WhatsApp',
                showDenyButton: true,
                denyButtonText: 'Entendido',
                customClass: {
                  confirmButton: 'btn btn-action-primary-outline mx-2',
                  denyButton: 'btn btn-action mx-2'
                },
                buttonsStyling: false
              }).then((result) => {
                if (result.isConfirmed) {
                  window.open( this.brandService.theme.name == 'Pervolare' ? 'https://wa.me/34910601741' : 'https://wa.me/13056868302', '_blank');
                }

                if (result.isDenied) {
                  this.router.navigate(['/refund']);
                }
              });
              return throwError(() => new Error('ALREADY_COMPLETED'));
            }
            Swal.fire({
                title: '<span class="text-primary">Aviso importante</span>',
                html: `<div style="color: #5F5F5F;">Este formulario tiene un único intento de diligenciamiento por caso o enlace.<br><br> No será posible volver a acceder ni editar la información una vez enviado.</div>`,
                confirmButtonText: 'Entendido',
                customClass: {
                  confirmButton: 'btn btn-action'
                },
                buttonsStyling: false
              });
            return of(response.result);
          } else {
            return throwError(() => new Error());
          }
        }),
        catchError((err) => {
          if (err && err.message === 'ALREADY_COMPLETED') {
            return EMPTY;
          }
          return this.getAssistanceOdoo(id).pipe(
            mergeMap(() => throwError(() => new Error('test'))),
          );
        }),
        retryWhen(
          genericRetryStrategy({
            maxRetryAttempts: 3,
            scalingDuration: 12000,
            excludedStatusCodes: [200],
          }),
        ),
        tap((res) => {
          this._assistance$.next(res);
          this.assistance$ = this._assistance$.asObservable();
        }),
      );
  }
  getAssistanceByNumberCase(id: number): Observable<Asistance> {
    return this.http
      .get<
        Response<Asistance>
      >(`${environment.serverUrl}/refund/Refund/GetAssistence/${id}`)
      .pipe(
        map((response) => response.result),
        tap((res) => {
          this._assistance$.next(res);
          this.assistance$ = this._assistance$.asObservable();
        }),
      );
  }

  getRefoundInfo(): Observable<RefoundInfo[]> {
    return this.http
      .get<RequestRefoundInfo>(
        `${environment.serverUrl}/refund/Refund/getTextRefund`,
      )
      .pipe(
        map((res) => res.result),
        tap((res) => {
          this._textRefunds$.next(res);
          this.textRefunds$ = this._textRefunds$.asObservable();
        }),
      );
  }

  addExpense(obj: any): Observable<number[]> {
    this.expensesLength.next(obj.length);

    return this.http
      .post<
        Response<number[]>
      >(`${environment.serverUrl}/refund/Refund/CreateExpense`, obj)
      .pipe(map((res) => res.result));
  }

  getTypeExpense(id: number): Observable<TypeExpense[]> {
    return this.http
      .get<RequestTypeExpense>(
        `${environment.serverUrl}/refund/Refund/GetTypeExpense/${id}`,
      )
      .pipe(map((res) => res.result));
  }

  getExpenseByCase(id: number): Observable<RequestStatusRefund | string> {
    return this.http
      .get<RequestStatusRefund>(
        `${environment.serverUrl}/refund/Refund/GetExpenseByCase/${id}`,
      )
      .pipe(
        map((data) => data),
        catchError(() => of('Error')),
      );
  }

  uploadFile(
    DocumentName: string,
    QuotationId: string,
    CustomerId: number,
    file: File,
  ): Observable<string> {
    return this.http.post<string>(
      `${environment.serverUrl}/document/Documents/UploadRefundFiles/${DocumentName}/${QuotationId}/${CustomerId}`,
      file,
    );
  }
  sendAsistanceDocument(body: any) {
    return this.http.post(
      `${environment.serverUrl}/refund/Refund/SendAssistanceDocument`,
      body,
    );
  }

  sendExpenseDocument(body: any) {
    return this.http.post(
      `${environment.serverUrl}/refund/Refund/SendDocumentbyExpense`,
      body,
    );
  }

  getDynamicFields(): Observable<DynamicFields[]> {
    console.log('--- LLAMADA A API DE CAMPOS DINÁMICOS DISPARADA ---');
    return this.http
      .get<
        Response<DynamicFields[]>
      >(`${environment.serverUrl}/refund/Refund/GetFieldsDynamic`)
      .pipe(
        map((res) => {
          console.log('Datos recibidos del backend:', res.result);
          return res.result;
        }),
        map((res) =>
          res.map((field) => ({
            ...field,
            jsonDynamic: JSON.parse((field.jsonDynamic as any) ?? '[]'),
          })),
        ),
      );
  }

  createDataBank(body: any) {
    return this.http.post(
      `${environment.serverUrl}/refund/Refund/CreateDataBank`,
      body,
    );
  }

  updateStateRefund(body: any) {
    return this.http
      .post(`${environment.serverUrl}/refund/Refund/UpdateStateRefund`, body)
      .subscribe((data) => data);
  }

  sendDocumentsSalesforce(body: SalesforceDocuments) {
    return this.http.post(
      `${environment.serverUrl}/refund/Refund/SendDocumentsSalesforce`,
      body,
    );
  }
}
